/*SYSTEM IMPORTS*/
import React from 'react'
import c from 'classnames'

import './style'
import './media'

const EducationTable = props => (
    <div className={c("education-table", props.className)}>
        <div className="education__title-row">
            <div className="education__title-column education__title-year">
                {props.TitleYear}
            </div>
            <div className="education__title-column education__title-name">
                {props.TitleName}
            </div>
        </div>
        <div className="education-table__body">
            {props.children}
        </div>
    </div>
) 

const EducationTableItem = props => (
    <div className={c("education__body-row", props.className)}>
        <div className="education__value-column education__value-year">
            {props.year}
        </div>
        <div className="education__value-column education__value-name">
            {props.name}
        </div>
    </div>
) 

export { EducationTableItem }
export default EducationTable
